<template>
  <div id="mask" v-show="false">
    <div class="voucher-count">
      <!-- 充值表单弹框 -->
      <el-dialog 
        class="self-demo-dialog" 
        center  
        width="90vw"    
        :visible.sync="voucherMobileShow"     
        @close="close"  
        append-to-body
      >
        <div class="voucher-title">《群侠传》充值</div>
        <el-form 
          :model="ruleForm" 
          :rules="rules" 
          name="ruleForm" 
          ref="ruleForm" 
          label-width="100px" 
          class="demo-ruleForm"
        >
          <el-form-item label="所在大区" prop="serverId">
            <el-select 
              v-model="ruleForm.serverId" 
              placeholder="请选择所在大区" 
              @change="handleServerChange"
            >
              <el-option
                v-for="item in serverList"
                :key="item.serverId"
                :label="item.serverName"
                :value="item.serverId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="安全手机" prop="phone">
            <el-input 
              v-model="ruleForm.phone"   
              autocomplete="off" 
              placeholder="请输入安全手机号码"
            ></el-input>
          </el-form-item>

          <el-form-item label="角色名称" prop="roleName">
            <el-select 
              v-model="ruleForm.roleName" 
              placeholder="请选择角色名称"  
              @click.native="getQueryRoles"
            >
              <el-option
                style="font-size: 16px;"
                v-for="item in rolesList"
                :key="item.roleName"
                :label="item.roleName"
                :value="item.roleName"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="充值金额" prop="rechargeId">
            <el-select
              v-model="ruleForm.rechargeId"
              :popper-append-to-body="false"
              placeholder="请选择充值档位"  
              @focus="handleRechargeClick"
            >
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.desc"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <!-- 立即充值按钮 -->
        <div class="topup" @click="topup()"></div>

        <div class="msg">
          <button 
            :class="{ 'is-selected': isSelected }" 
            @click="toggleSelection"
          >
            {{ isSelected ? '' : '' }}
          </button>
          我同意
          <a @click="footerSkip(footer.userAgreement)">{{
            footer.userAgreement.title
          }}</a>
          {{ " | " }}
          <a @click="footerSkip(footer.privacyPolicy)">{{
            footer.privacyPolicy.title
          }}</a>
        </div>

        <div style="display: flex; align-items: center"  class="message-content">
          温馨提示:充值比例为1元=10元宝 支持微信和支付宝
        </div>
      </el-dialog>

      <!-- 微信二维码支付弹框 -->
      <!-- 支付选择弹框 -->
      <div id="voucherPay">
        <el-dialog  
          class="voucher-pay-dialog" 
          center 
          width="360px"  
          :visible.sync="voucherPayShow"  
          append-to-body
        >
          <div class="voucherPay">
            <!-- 支付方式选择 -->
            <div class="pay-type-selector" style="margin-bottom: 20px; text-align: center;">
              <el-radio-group v-model="selectedPayType" @change="handlePayTypeChange">
                <el-radio label="wechat" style="margin-right: 20px;">
                  <img src="../../../assets/image/pc/recharge/wxpay-01.png" alt="微信支付" style="width: 20px; height: 20px; margin-right: 5px;">
                  微信支付
                </el-radio>
                <el-radio label="alipay">
                  <img src="../../../assets/image/pc/recharge/zfbpay-01.png" alt="支付宝支付" style="width: 20px; height: 20px; margin-right: 5px;">
                  支付宝支付
                </el-radio>
              </el-radio-group>
            </div>
            
            <!-- 未选择支付方式时提示 -->
            <div v-if="!hasSelectedPayType" class="self-qr-desc error-tip">
              请先选择支付方式
            </div>
            
            <!-- 选择支付方式后显示二维码 -->
            <div v-else class="qr-code-container" style=" margin-left:45px">
      
              <!-- 二维码加载中 -->
              <div v-if="!qrCodeImg" class="loading-tip">正在生成支付二维码...</div>
              <!-- 显示二维码 -->
              <img v-else :src="qrCodeImg" class="qr-code-img" />
              <!-- 支付错误提示 -->
              <div v-if="payErrorMsg" class="error-tip">
                {{ payErrorMsg }}
              </div>
              <!-- 支付方式提示 -->
             
            </div>
            <div class="self-qr-footer">
                <!-- <img 
                  :src="selectedPayType === 'wechat' ? '../../assets/image/pc/recharge/wxpay-01.png' : '../../assets/image/pc/recharge/zfbpay-01.png'" 
                  alt 
                  style="width: 20px; height: 20px;"
                />  -->
                <p>{{ selectedPayType === 'wechat' ? '微信扫码' : '支付宝扫码' }}</p>
              </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import utils from "../../../utils";
import { mapMutations } from "vuex";
import recharApi from '../../../api/rechargeApi'

export default {
  props: {},
  data() {
    // 手机号校验规则
    const checkPhone = (rule, value, callback) => {
      const reg = /^1[3456789]\d{9}$/;
      if (!value) {
        callback(new Error("请输入安全手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("安全手机号码格式不正确"));
      } else {
        callback();
      }
    };

    // 去除空格校验
    const noSpaces = (rule, value, callback) => {
      if (value && value.indexOf(' ') >= 0) {
        callback(new Error('输入值不能包含空格'));
      } else {
        callback();
      }
    };

    return {
      isSelected: false,          // 是否同意协议
      voucherMobileShow: false,   // 充值表单弹框显示状态
      productList: [],            // 充值档位列表
      serverList: [],             // 服务器列表
      rolesList: [],              // 角色列表
      voucherPayShow: false,      // 支付二维码弹框显示状态
      buttonCheck: '',            // 按钮校验标识
      elementId: 'initialId',     // 元素ID
      codeUrl: '',                // 支付二维码链接
      qrCodeImg: '',              // 二维码图片base64
      qrCodeErrorMsg: '',         // 二维码生成错误提示
      payAmountText: '',          // 支付金额文本（如：6元）
      selectedPayType: '',        // 选中的支付方式（新增）
      payErrorMsg: '',            // 支付错误提示（新增）
      payAmount: 0,               // 支付金额（新增）
      
      // 表单数据
      ruleForm: {
        appSource: "official",
        channelId: "official",
        deviceId: "4",
        payId: "302",              // 微信支付ID
        playerId: "0",
        rechargeId: '',            // 充值档位ID
        roleId: "0",
        serverId: '',              // 服务器ID
        phone: "",                 // 安全手机号
        roleName: "",              // 角色名称
        p700: { phone: '', roleName: '',  payWay:'WEIXIN', payType:'SCANPAY_WEIXIN'},//微信支付参数
        p200: { phone: '', roleName: '' },//支付宝支付参数
      },
      
      // 表单校验规则
      rules: {
        roleName: [
          { required: true, message: '请选择角色名称', trigger: 'change' },
          { min: 1, max: 25, message: '长度在 1 到 25 个字符', trigger: 'change' },
          { validator: noSpaces, trigger: 'change' }
        ],
        serverId: [
          { required: true, message: '请选择所在大区', trigger: 'change' }
        ],
        rechargeId: [
          { required: true, message: '请选择充值金额', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入安全手机号码', trigger: 'blur' },
          { validator: noSpaces, trigger: 'blur' },
          { validator: checkPhone, trigger: "blur" }
        ]
      }
    };
  },

  computed: {
    // 获取页脚协议配置
    footer() {
      return this.$config.footer || {
        userAgreement: { title: '用户协议' },
        privacyPolicy: { title: '隐私政策' }
      };
    },
    // 判断是否选择了支付方式（新增）
    hasSelectedPayType() {
      return !!this.selectedPayType;
    }
  },

  mounted() {
    // 页面加载时获取服务器列表
    this.getServerUrls();
  },
 
  methods: {
    // 关闭弹框
    close() {
      this.$emit("VoucherClose", false);
      // 重置表单和状态
      this.resetFormState();
    },

    // 重置表单状态
    resetFormState() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      this.isSelected = false;
      this.productList = [];
      this.rolesList = [];
      this.qrCodeImg = '';
      this.qrCodeErrorMsg = '';
      this.payAmountText = '';
      this.selectedPayType = ''; // 重置支付方式
      this.payErrorMsg = '';      // 重置错误信息
    },

    // 切换协议同意状态
    toggleSelection() {
      this.isSelected = !this.isSelected;
    },

    // 跳转协议详情
    async footerSkip(item) {
      try {
        const { id, title, type } = item;
        this.$router.push({ path: "/detail", query: { id, title, type } });
      } catch (error) {
        this.$message.error('跳转失败，请重试');
      }
    },

    // 服务器切换事件
    async handleServerChange(serverId) {
      if (serverId) {
        this.ruleForm.rechargeId = '';
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate('rechargeId');
        }
        this.productList = [];
      } else {
        this.productList = [];
        this.ruleForm.rechargeId = '';
      }
    },

    // 充值档位选择框聚焦事件
    async handleRechargeClick() {
      if (this.ruleForm.serverId) {
        await this.getProductUrls(this.ruleForm.serverId);
        this.ruleForm.rechargeId = '';
      } else {
        this.productList = [];
        this.$message.warning('请先选择所在大区');
      }
    },

    // 获取充值档位列表
    async getProductUrls(serverId) {
      try {
        const params = { serverId: serverId };
        const res = await recharApi.getProductUrls(params);
        if (res && res.data) {
          this.productList = res.data;
        } else {
          this.productList = [];
          this.$message.warning('暂无充值档位数据');
        }
      } catch (error) {
        this.productList = [];
        this.$message.error('获取充值档位失败，请重试');
        console.error('getProductUrls error:', error);
      }
    },

    // 获取服务器列表
    async getServerUrls() {
      try {
        const res = await recharApi.getServerUrls();
        if (res && res.data) {
          this.serverList = res.data;
        } else {
          this.serverList = [];
          this.$message.warning('暂无服务器数据');
        }
      } catch (error) {
        this.serverList = [];
        this.$message.error('获取服务器列表失败，请重试');
        console.error('getServerUrls error:', error);
      }
    },

    // 获取角色列表
    async getQueryRoles() {
      const { phone, serverId } = this.ruleForm;
      
      // 校验服务器
      if (!serverId || serverId <= 0) {
        this.$message.error("请选择服务器！");
        return;
      }
      
      // 校验手机号
      if (!phone) {
        this.$message.error("请先输入安全手机号码！");
        return;
      }
      
      try {
        const params = { 
          currentPhone: Number(phone), 
          serverId: Number(serverId)
        };
        const res = await recharApi.getQueryRoles(params);
        
        if (res && res.data) {
          this.rolesList = res.data;
          // 无角色提示
          if (this.rolesList.length === 0) {
            this.$message.warning('未查询到该手机号对应的角色信息');
          }
        } else {
          this.rolesList = [];
          this.$message.warning('暂无角色数据');
        }
      } catch (error) {
        this.rolesList = [];
        this.$message.error('查询角色信息失败，请重试');
        console.error('getQueryRoles error:', error);
      }
    },

    // 生成二维码
    createQR(codeUrl) {
      // 清空之前的状态
      this.qrCodeImg = '';
      this.qrCodeErrorMsg = '';
      
      if (!codeUrl) {
        this.qrCodeErrorMsg = '支付链接为空，无法生成二维码';
        return;
      }

      const opts = {
        errorCorrectionLevel: "H", // 容错级别
        type: "image/png",         // 二维码类型
        quality: 0.8,              // 二维码质量（提高质量）
        margin: 2,                 // 留白边距
        width: 150,                // 宽度（适配移动端）
        height: 150,               // 高度
        color: {
          dark: "#000",            // 前景色
          light: "#fff"            // 背景色
        }
      };

      QRCode.toDataURL(codeUrl, opts, (err, url) => {
        if (err || !url) {
          this.qrCodeErrorMsg = "支付二维码生成失败，请重试";
          this.$message.error(this.qrCodeErrorMsg);
          console.error('QRCode generate error:', err);
          return;
        }
        this.qrCodeImg = url;
      });
    },

    // 切换支付方式
    handlePayTypeChange() {
      // 清空原有二维码和错误信息
      this.qrCodeImg = '';
      this.payErrorMsg = '';
      
      // 根据选择的支付方式更新payId
      this.ruleForm.payId = this.selectedPayType === 'wechat' ? '700' : '200';
      
      // 根据选择的支付方式调用对应的二维码获取方法
      if (this.selectedPayType === 'alipay') {
        this.getAlipayPayQrCode();
      } else if (this.selectedPayType === 'wechat') {
        this.getPayQrCode();
      }
    },

    // 获取微信支付二维码
    async getPayQrCode() {
      try {
        const params = Object.assign({}, this.ruleForm);
        params.p700.roleName = params.roleName;
        params.p700.phone = params.phone;
        params.p700.payWay = 'WEIXIN';
        params.p700.payType ='SCANPAY_WEIXIN';
        delete params.p200;
        
        let res = await recharApi.unifiedOrder(params);
        
        if (res.code == 200) {
          this.createQR(res.data.p700.qrCode);
        } else {
          this.payErrorMsg = res.message || "获取支付二维码失败，请重试！";
          if (res.code == 40002) {
            this.payErrorMsg = "用户信息有误！";
          }
        }
      } catch (error) {
        this.payErrorMsg = "网络异常，获取支付二维码失败！";
      }
    },

    // 获取支付宝支付二维码
    async getAlipayPayQrCode() {
      try {
        // 组装请求参数
        const params = Object.assign({}, this.ruleForm);
        params.p200 = {
          roleName: params.roleName,
          phone: params.phone
        };
        delete params.p700;
        
        // 调用统一下单接口
        let res = await recharApi.unifiedOrder(params);
        
        // 支付宝返回的是grCode字段，不是codeUrl
        if (res.code === 200 && res.data && res.data.p200 && res.data.p200.qrCode) {
          // 使用支付宝返回的grCode生成二维码
          this.createQR(res.data.p200.qrCode);
          
          // 可选：显示订单金额信息
          if (res.data.p200.payAmount) {
            this.payAmount = res.data.p200.payAmount;
          }
        } else {
          this.payErrorMsg = res.message || "获取支付宝支付二维码失败，请重试！";
          if (res.code === 40002) {
            this.payErrorMsg = "用户信息有误！";
          }
          this.qrCodeImg = '';
        }
      } catch (error) {
        console.error('支付宝支付二维码获取失败:', error);
        this.payErrorMsg = "网络异常，获取支付宝支付二维码失败！";
        this.qrCodeImg = '';
      }
    },
    
    // 充值
    async topup() {
      // 检查是否同意协议
      if (!this.isSelected) {
        this.$message({
          type: 'error',
          message: "用户协议未同意"
        });
        return;
      }

      // 表单验证
      try {
        await this.$refs.ruleForm.validate();
        
        // 显示支付选择弹框，但不默认生成任何二维码
        this.voucherPayShow = true;
        // 清空原有支付状态
        this.selectedPayType = '';
        this.ruleForm.payId = '';
        this.qrCodeImg = '';
        this.payErrorMsg = '';
        
      } catch (error) {
        // 表单验证失败
        return false;
      }
    },
  }
};
</script>


<style lang="scss" scoped>
.voucher-count {
  width: 100%;
  ::v-deep .el-dialog--center {
    border: 1px solid;
    border-radius: 2%;
  }
}

// 充值表单弹框样式
.self-demo-dialog {
  position: inherit;
  ::v-deep .el-form-item__label {
    position: relative;
  }
  ::v-deep .el-dialog {
    background-image: url('../../../assets/image/pc/recharge/bjmobile.png');
    background-size: 100% 100%;
    background-color: transparent;
    border-radius: 3%;
    -webkit-box-shadow: 0 1px 3px transparent;
    box-shadow: 0 1px 3px transparent;
  }
  ::v-deep .el-dialog_body {
    padding: 15px auto !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  ::v-deep .el-dialog__header {
    padding: 0px 10px 10px;
  }
  ::v-deep .el-form-item__label:before {
    display: inline-block;
    position: relative;
    top: 3px;
    left: -2px;
    content: '' !important;
    width: 14px;
    height: 16px;
    background: url(../../../assets/image/pc/recharge/lx.png) no-repeat !important;
    background-size: 14px 16px !important;
  }
  ::v-deep .el-form {
    width: 100%;
  }
  ::v-deep .el-form-item__label {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    color: #502d07;
  }
  ::v-deep .el-input:focus {
    font-size: 16px !important;
  }
  ::v-deep .el-dialog__close {
    color: #502d07;
    font-size: 20px;
    line-height: 4px;
  }
  ::v-deep .el-select {
    width: 100%;
    max-width: 300px;
  }
  ::v-deep .el-input {
    width: 100%;
    max-width: 300px;
  }
}

// 通用弹框样式
::v-deep .el-dialog__body {
  padding: 15px !important;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

// 二维码支付部分基础样式
.self-qr-desc {
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
}

// 重点：单独给 self-qr-footer 加穿透（关键修复）
::v-deep .self-qr-footer {
  display: flex !important;        /* 强制生效 flex 布局 */
  align-items: center !important;  /* 垂直居中 */
  justify-content: center !important; /* 水平居中 */
  margin-top: 15px !important;
  width: 100% !important;          /* 占满宽度 */
  
  img {
    width: 20px !important;
    height: 20px !important;
    margin-right: 8px !important;  /* 图标和文字间距 */
    display: inline-block !important; /* 行内块元素 */
    vertical-align: middle !important;
  }
  
  p {
    font-size: 16px !important;
    margin: 0 !important;          /* 清除默认边距 */
    line-height: 20px !important;  /* 行高和图片一致 */
    display: inline-block !important;
    vertical-align: middle !important;
  }
}

// 支付弹窗样式（重点修复）
::v-deep .voucher-pay-dialog {
  .el-dialog__body {
    padding: 20px !important;
  }
  
  .voucherPay {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    .pay-type-selector {
      width: 100%;
      margin-bottom: 20px;
      
      .el-radio {
        font-size: 16px;
        margin: 0 10px;
      }
    }
    
    .error-tip {
      color: #ff4d4f;
      font-size: 14px;
      margin: 10px 0;
    }
    
    .loading-tip {
      font-size: 14px;
      color: #666;
      margin: 20px 0;
    }
    
    .qr-code-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      
      .qr-code-img {
        width: 250px;
        height: 250px;
        margin: 10px 0;
        border: 1px solid #eee;
        padding: 10px;
      }
    }
  }
}

// 标题样式
.voucher-title {
  font-size: 24px;
  color: #77420c;
  font-weight: 800;
  margin-bottom: 4%;
  text-align: center;
}

// 提示文本样式
.message-content {
  height: 5%;
  font-size: 12px;
  text-align: center;
  color: red;
  font-weight: bold;
  margin: 10px 0;
}

// 充值按钮样式
.topup {
  width: 100px;
  height: 32px;
  text-align: center;
  line-height: 35px;
  margin: 10px auto;
  background-size: 100% 100%;
  color: #eac46c;
  cursor: pointer;
  background-image: url('../../../assets/image/pc/recharge/anpc.png');
}

.noimg {
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  border-radius: 5px;
  img {
    width: 18px;
    height: 12 px;
  }
}

// 协议勾选样式
.msg {
  font-size: 12px;
  font-weight: bold;
  color: #502d07;
  margin-bottom: 1%;
  text-align: center;
  
  a {
    text-decoration: underline;
    cursor: pointer;
  }
  
  button {
    padding: 2%;
    background-color: #fbf8f1;
    border: 1px solid #fbf8f1;
    width: 15px;
    height: 15px;
    border-radius: 15%;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.is-selected {
  width: 16px;
  height: 18px;
  background: url(../../../assets/image/pc/recharge/check.png) no-repeat !important;
  background-size: 12px 10px !important;
}
</style>